
export enum GeofenceType {
    Polygon = 0, // dbgeograph POINT
    Circle = 1
}
